<app-list-header [headerName]="'Все уроки'"></app-list-header>
<app-lessons-list
  [studentClassId]="classId"
  [subjectId]="subjectId"
  [showHeader]="true"
  *ngIf="classId && subjectId">
</app-lessons-list>
